export const LIMIT_IN_MOBILE_VIEW = 3;
export const LIMIT_IN_TAB_VIEW = 6;
